import { createAction, props } from '@ngrx/store';

import { Delivery } from '../../models/delivery.model';
import {
  ActiveDelivery,
  PostManualDeliveryRequest,
  ShowInFinalSetupDeliveryRequest,
} from '../../models/flock-registration-service.model';

export const loadDeliveriesRequest = createAction(
  '[Delivery] Load deliveries request',
  props<{ startDate?: string; endDate?: string }>(),
);
export const loadDeliveriesSuccess = createAction(
  '[Delivery] Load deliveries success',
  props<{ deliveries: Delivery[] }>(),
);
export const loadDeliveriesFailed = createAction(
  '[Delivery] Load deliveries failed',
  props<{ error: Error }>(),
);

export const upsertActiveDeliveriesRequest = createAction(
  '[Delivery] Upsert active deliveries request',
  props<{ activeDelivery: ActiveDelivery }>(),
);
export const upsertActiveDeliveriesSuccess = createAction(
  '[Delivery] Upsert active deliveries success',
  props<{ delivery: ActiveDelivery }>(),
);
export const upsertActiveDeliveriesFailed = createAction(
  '[Delivery] Upsert active deliveries failed',
  props<{ error: Error }>(),
);

export const upsertManualDeliveryRequest = createAction(
  '[Delivery] Upsert manual delivery request',
  props<{ manualDeliveryRequest: PostManualDeliveryRequest }>(),
);
export const upsertManualDeliverySuccess = createAction(
  '[Delivery] Upsert manual delivery success',
);
export const upsertManualDeliveryFailed = createAction(
  '[Delivery] Upsert manual delivery failed',
  props<{ error: Error }>(),
);
export const removeManualDeliveryRequest = createAction(
  '[Delivery] Remove manual delivery request',
  props<{ manualDeliveryId: number }>(),
);
export const removeManualDeliverySuccess = createAction(
  '[Delivery] Remove manual delivery success',
);
export const removeManualDeliveryFailed = createAction(
  '[Delivery] Remove manual delivery failed',
  props<{ error: Error }>(),
);
export const setDeliveriesFilter = createAction(
  '[Delivery] Set deliveries filter',
  props<{ startDate?: string; endDate?: string }>(),
);

export const upsertShowInFinalSetupDeliveriesRequest = createAction(
  '[Delivery] Upsert ShowInFinalSetup deliveries request',
  props<{ request: ShowInFinalSetupDeliveryRequest }>(),
);
export const upsertShowInFinalSetupDeliveriesSuccess = createAction(
  '[Delivery] Upsert ShowInFinalSetup deliveries success',
  props<{ request: ShowInFinalSetupDeliveryRequest }>(),
);
export const upsertShowInFinalSetupDeliveriesFailed = createAction(
  '[Delivery] Upsert ShowInFinalSetup deliveries failed',
  props<{ error: Error }>(),
);
